var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonalTeamLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1004 33.457C37.4096 30.266 45.4062 21.7139 45.4062 15.8756C45.4062 10.6741 40.9689 6.45703 35.4955 6.45703C31.8193 6.45703 28.6168 8.36461 26.9062 11.1902C25.1957 8.36461 21.9932 6.45703 18.317 6.45703C12.8436 6.45703 8.40625 10.6741 8.40625 15.8756C8.40625 20.0782 12.5503 25.6879 16.4802 29.6908",
    fill: "#E4C1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 36.2724L6.76231 34.3691L13.0381 44.5436L9.18671 46.9167",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 35.1988L7.1968 33.1035L14.1973 44.3043L9.90117 46.9169",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2026 34.5067L29.5955 34.5017C31.1405 34.5017 32.3929 33.2494 32.3929 31.7036C32.3929 30.1586 31.1405 28.9062 29.5955 28.9062L18.8931 28.9112C17.6547 28.9112 16.438 29.2402 15.3691 29.8639L8.60938 33.8073",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2026 34.5067L29.5955 34.5017C31.1405 34.5017 32.3929 33.2494 32.3929 31.7037C32.3929 30.1586 31.1405 28.9062 29.5955 28.9062L18.8931 28.9112C17.6547 28.9112 16.438 29.2402 15.3691 29.8639L8.60938 33.8073",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2974 34.4978L42.5343 29.1284C43.9575 28.5383 45.6033 29.2208 46.1928 30.6433C46.7822 32.0665 46.1004 33.7131 44.6779 34.3025L32.3066 40.2438C31.4434 40.6092 30.5145 40.7983 29.5764 40.7983H18.5821C17.8212 40.7983 17.0742 41.0048 16.4225 41.3961L13.9219 42.8977",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2974 34.4978L42.5343 29.1284C43.9575 28.5383 45.6033 29.2208 46.1928 30.6433C46.7822 32.0665 46.1004 33.7131 44.6779 34.3025L32.3066 40.2438C31.4434 40.6092 30.5145 40.7983 29.5764 40.7983H18.5821C17.8212 40.7983 17.0742 41.0048 16.4225 41.3961L13.9219 42.8977",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3636 33.1022C37.9293 29.5445 46.402 20.0098 46.402 13.5008C46.402 7.70154 41.7005 3 35.9013 3C32.0062 3 28.613 5.12675 26.8006 8.27698C24.9882 5.12675 21.595 3 17.7 3C11.9008 3 7.19922 7.70154 7.19922 13.5008C7.19922 18.1862 11.5899 24.4404 15.7538 28.9033",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalTeamLogo);
export default __webpack_public_path__ + "static/media/PersonalTeamLogo.1f29d9d1a55b090084d0be60c2724cc8.svg";
export { ForwardRef as ReactComponent };